<!-- IncludeInPresentationToggle.vue -->
<template>
  <div class="tw-flex tw-items-center justify-between font-inter tw-text-sm tw-gap-6">
    <div class="tw-whitespace-nowrap tw-font-medium">Include in presentation</div>
    <o-switch
      :value="isIncluded"
      variant="success"
      position="left"
      @input="handleToggle"
    />
  </div>
</template>


<script>
import { mapStores } from 'pinia';
import { useCheckupStore } from '@frontend/ui/stores/checkupStore';
import { useAdvisorStore } from '@frontend/ui/stores/advisorStore';

export default {
  name: 'AnalysisSlideToggle',
  components: { /* Subcomponents */ },
  props: ['name'],
  data() {
    return { /* Local variables */ };
  },
  computed: {
    ...mapStores(useCheckupStore, useAdvisorStore),
    isIncluded() {
      const pageSetting = this.advisorStore.pageSettings[this.name];
      return pageSetting ? pageSetting.isIncluded : true;
    },
  },
  watch: {
    isIncluded(newValue) {
      this.handleToggle(newValue);
    },
  },
  mounted() {
    this.handleToggle(this.isIncluded);
  },
  methods: {
    handleToggle(include) {
      this.checkupStore.toggleSlide(this.name, include);
    },
  },
};
</script>


<style scoped>

</style>
